import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Dimmer,
  Header,
  Icon,
  Loader,
  Modal,
  Table,
} from 'semantic-ui-react';
import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import config from '../../../config';
import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { promptChangesMessage } from '../../actions/prompt';
import { decodeSearch, encodeSearch } from '../../utils/url';
import isNumber from '../../utils/numbers/isNumber';
import fileSize from '../../utils/fileSize';
// import PageNav from '../../components/PageNav';
import NavBar from '../../components/NavBar';
import {
  UPLOAD_DOCUMENT_PROMPT,
} from '../../constants/promptMessages';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

import Form from './Form';

class List extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    t: PropTypes.func,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    const count = props.count;
    const limit = props.limit;
    const offset = props.offset;
    const data = props.data || [];
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    return {
      data,
      loading,
      count,
      limit,
      offset,
      currentPage,
    };
  }
  constructor(props) {
    super(props);
    const state = List.getPropsToState(props);
    this.state = {
      ...state,
      selectedFile: null,
      showDelete: false,
      showUpload: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = List.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  getToken = (id, callback) => {
    const { store } = this.context;
    store.dispatch(fetchM(`/company_documents/${id}/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      })
      .then((res) => {
        const token = res.headers.get('X-Csrf-Token');
        if (callback) {
          callback(token);
        }
      });
  }
  replaceQuery(query) {
    const { store } = this.context;
    store.dispatch(replace(`/settings/company_documents/?${encodeSearch(query)}`));
  }
  handleChangePage = (page) => {
    const query = decodeSearch(this.props.location.search);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    const currentPage = parseInt(page || query.page, 10);
    query.page = currentPage;
    this.setState({ currentPage });
    this.replaceQuery(query);
  }
  handleCancelDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDelete: false,
      selectedFile: null,
    });
  }
  handleDelete = (e, selectedFile) => {
    e.preventDefault();
    this.setState({
      selectedFile,
      showDelete: true,
    });
  }
  handleConfirmDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDelete: false,
      loading: true,
    }, () => {
      this.deleteCompanyDocument();
    });
  }
  deleteCompanyDocument() {
    const { store } = this.context;
    const { selectedFile } = this.state;
    const { t } = this.props;
    this.getToken(selectedFile.id, (token) => {
      store.dispatch(fetchM(`/company_documents/${selectedFile.id}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': token,
        },
      }))
        .then(() => {
          this.setState({
            selectedFile: null,
            loading: false,
          });
          this.handleChangePage();
          store.dispatch(flashSuccessMessage({
            header: t('Delete Success', { ns: TRANSLATION_FILES.translation }),
            message: t('Company Document ({{name}}) successfully deleted', { name: selectedFile.name, ns: TRANSLATION_FILES.translation }),
          }));
        })
        .catch((err) => {
          store.dispatch(flashErrorMessage(err));
        });
    });
  }
  uploadCompanyDocument = (e, body) => {
    e.preventDefault();
    const { selectedFile } = this.state;
    const { store } = this.context;
    const { t } = this.props;
    this.getToken(selectedFile.id, (token) => {
      this.form.submit(`/company_documents/${selectedFile.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': token,
        },
        body,
      })
        .then(() => {
          this.handleCloseUpload(e, true);
          this.handleChangePage();
          store.dispatch(flashSuccessMessage({
            header: t('Upload Success', { ns: TRANSLATION_FILES.translation }),
            message: t('Company Document ({{name}}) successfully uploaded', { name: selectedFile.name, ns: TRANSLATION_FILES.translation }),
          }));
        })
        .catch((err) => {
          if (err.res && err.res.status >= 400 && err.res.status < 500) {
            const message = err.res.text();
            store.dispatch(flashErrorMessage({ message }));
            return;
          }
          store.dispatch(flashErrorMessage(err));
        });
    });
  }
  handleCheckBeforeClose = () => {
    const { t } = this.props;
    if (this.form.state.upload && this.form.state.upload.file) {
      const callback = () => {
        this.handleCloseUpload(null, true);
        this.handleChangePage();
      };
      const { store } = this.context;
      store.dispatch(promptChangesMessage({ message: t(UPLOAD_DOCUMENT_PROMPT, { ns: TRANSLATION_FILES.translation }), callback }));
      return true;
    }
    return false;
  }
  handleCloseUpload = (e, force = false) => {
    if (e) e.preventDefault();
    let showUpload = false;
    let selectedFile = null;
    if (!force) {
      showUpload = this.handleCheckBeforeClose();
      selectedFile = this.state.selectedFile;
    }
    this.setState({
      showUpload,
      selectedFile,
    });
  }
  handleUpload= (e, selectedFile) => {
    e.preventDefault();
    this.setState({
      selectedFile,
      showUpload: true,
    });
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Company Documents')}
        />
        <Modal
          open={this.state.showDelete}
          onClose={this.handleCancelDelete}
        >
          <Header icon="warning sign" content={`${t('Confirm delete')}?`} />
          <Modal.Content>
            <Modal.Description>
              <Header
                as="h3"
                content={`${t('Are you sure to delete this file')}?`}
                subheader={this.state.selectedFile ? this.state.selectedFile.name : ''}
              />
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button basic negative onClick={this.handleCancelDelete} icon="cancel" content={t('No', { ns: TRANSLATION_FILES.constants })} inverted />
            <Button basic positive onClick={this.handleConfirmDelete} icon="trash" content={t('Yes', { ns: TRANSLATION_FILES.constants })} inverted />
          </Modal.Actions>
        </Modal>
        <Modal
          className="upload-modal"
          open={this.state.showUpload}
          onClose={e => this.handleCloseUpload(e, false)}
          closeIcon="close"
        >
          <Header icon="cloud upload" content={t('Upload file for {{name}}', { name: this.state.selectedFile ? this.state.selectedFile.name : '', ns: TRANSLATION_FILES.screens })} />
          <Modal.Content>
            <Form
              ref={(ref) => { this.form = ref; }}
              file={this.state.selectedFile}
              onSubmit={this.uploadCompanyDocument}
            />
          </Modal.Content>
        </Modal>
        <Dimmer
          inverted style={{ zIndex: 20 }}
          active={this.state.loading && this.state.data.length > 0}
        >
          <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
        </Dimmer>
        <Table
          striped unstackable
          selectable
        >
          <Table.Header fullWidth>
            {/* <Table.Row>
              <Table.HeaderCell colSpan={4} textAlign="right">
                <PageNav
                  currentPage={this.state.currentPage}
                  count={this.state.count}
                  limit={this.state.limit}
                  offset={this.state.offset}
                  dataSize={this.state.data.length}
                  loading={this.state.loading}
                  onChange={this.handleChangePage}
                />
              </Table.HeaderCell>
            </Table.Row> */}
            <Table.Row>
              <Table.HeaderCell>{t('Name')}</Table.HeaderCell>
              <Table.HeaderCell>{t('Size')}</Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {
              this.state.data.length > 0 ?
                this.state.data.map((file, key) => (
                  <Table.Row key={key}>
                    <Table.Cell width={6}>
                      {
                        file.key ? (
                          <a
                            href={`${config.get('bookApiURL')}/company_documents/${file.id}/view/${file.key.substring(file.key.lastIndexOf('/') + 1)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Icon name="file outline" />
                            {file.name}
                          </a>
                        ) : (
                          <div>
                            <Icon name="file outline" />
                            {file.name}
                          </div>
                        )
                      }
                    </Table.Cell>
                    <Table.Cell collapsing>
                      {file.size ? fileSize(file.size) : '-'}
                    </Table.Cell>
                    <Table.Cell collapsing textAlign="right">
                      {
                        file.key ? (
                          <div>
                            <Button
                              compact
                              primary
                              icon="edit"
                              disabled={this.state.loading}
                              onClick={e => this.handleUpload(e, file)}
                            />
                            <Button
                              compact
                              negative
                              icon="delete"
                              disabled={this.state.loading}
                              onClick={e => this.handleDelete(e, file)}
                            />
                          </div>
                        ) : (
                          <Button
                            disabled={this.state.loading}
                            primary
                            icon="cloud upload"
                            labelPosition="left"
                            content={t('Upload', { ns: TRANSLATION_FILES.translation })}
                            onClick={e => this.handleUpload(e, file)}
                          />
                        )
                      }
                    </Table.Cell>
                  </Table.Row>
                ))
              :
                <Table.Row>
                  <Table.Cell colSpan={4} textAlign="center">
                    {
                      this.state.loading ?
                        <Loader active inline="centered">Loading</Loader>
                      : `${t('No company documents found')}.`
                    }
                  </Table.Cell>
                </Table.Row>
            }
          </Table.Body>
          {/* <Table.Footer fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan={4} textAlign="right">
                <PageNav
                  currentPage={this.state.currentPage}
                  count={this.state.count}
                  limit={this.state.limit}
                  offset={this.state.offset}
                  dataSize={this.state.data.length}
                  loading={this.state.loading}
                  onChange={this.handleChangePage}
                />
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer> */}
        </Table>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(List);



// WEBPACK FOOTER //
// ./src/containers/CompanyDocuments/List.jsx